import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material Modules
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule } from "@angular/material/menu";
import { MatDialogModule } from "@angular/material/dialog";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatStepperModule } from "@angular/material/stepper";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { BidiModule } from "@angular/cdk/bidi";

// Third Party
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { LazyLoadImageModule, LAZYLOAD_IMAGE_HOOKS, ScrollHooks } from "ng-lazyload-image";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { VirtualScrollerModule } from "ngx-virtual-scroller";
import { VirtualScrollModule } from "ngx-virtual-scroll-plus";
import { SwiperModule } from "swiper/angular";

// Pipes
import { FilterCityPipe } from "../pipes/filter-city.pipe";
import { LimitToPipe } from "../pipes/limit-to.pipe";
import { HighlighterPipe } from "../pipes/highlighter.pipe";
import { OfflineFilterPipe } from "../pipes/offline-filter.pipe";
import { CouncodePipe } from "../pipes/councode.pipe";
import { DurationToHourMinPipe } from "../pipes/duration-to-hour-min.pipe";
import { HourMinutePipe } from "../pipes/hour-minute.pipe";
import { ExchangePipe } from "../pipes/exchange.pipe";
import { HotelecitesPipe } from "../pipes/hotelecites.pipe";

const PIPES = [
  FilterCityPipe,
  LimitToPipe,
  HighlighterPipe,
  OfflineFilterPipe,
  CouncodePipe,
  DurationToHourMinPipe,
  HourMinutePipe,
  ExchangePipe,
  HotelecitesPipe
];

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  MatSnackBarModule,
  MatRadioModule,
  MatSelectModule,
  MatInputModule,
  MatButtonModule,
  MatNativeDateModule,
  MatRippleModule,
  MatFormFieldModule,
  MatExpansionModule,
  MatMenuModule,
  MatDialogModule,
  MatPaginatorModule,
  MatDatepickerModule,
  MatStepperModule,
  MatAutocompleteModule,
  MatCardModule,
  MatListModule,
  MatTooltipModule,
  MatSidenavModule,
  MatTabsModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
  MatIconModule,
  BidiModule,
  FontAwesomeModule,
  TranslateModule,
  NgbModule,
  NgbCollapseModule,
  LazyLoadImageModule,
  NgxIntlTelInputModule,
  NgxSliderModule,
  VirtualScrollerModule,
  VirtualScrollModule,
  SwiperModule
];

@NgModule({
  declarations: [
    ...PIPES
  ],
  imports: [
    ...MODULES
  ],
  exports: [
    ...MODULES,
    ...PIPES
  ],
  providers: [
    HourMinutePipe, // Providing pipes if they are injected
    ExchangePipe,
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks },
    { provide: MatPaginatorIntl }
  ]
})
export class SharedUiModule { }
